import { useEffect, useState } from 'react';
import { FaStar, FaCheckCircle } from "react-icons/fa";
import Meta from '../../components/Meta';
import { ErrorToast, SuccessToast } from '../../helper/FormHelper';
import axiosInstance from '../../helper/axiosInstance';

export default function HomePage() {
  const [responsive, setResponsive] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [entity, setEntity] = useState('');
  const [state, setState] = useState('');

  useEffect(() => {
    const onResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 576);
      setIsTablet(width >= 576 && width < 768);
      setResponsive(width < 768);
    };
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone) {
      ErrorToast("Please fill in all required fields");
      return;
    }
    setLoading(true);
    try {
      await axiosInstance.post('/contact', formData);
      SuccessToast("Thank you! We'll contact you soon.");
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      ErrorToast(error.response?.data?.message || "Failed to submit form");
    } finally {
      setLoading(false);
    }
  };

  const handleEntityChange = (e) => {
    setEntity(e.target.value);
  };

  const handleStateChange = (e) => {
    setState(e.target.value);
  };

  const fontSize = (desktop, mobile) => responsive ? mobile : desktop;

  // Responsive utilities
  const getPadding = (dTop, dRight, dBottom, dLeft, mTop, mRight, mBottom, mLeft) => 
    responsive ? `${mTop} ${mRight} ${mBottom} ${mLeft}` : `${dTop} ${dRight} ${dBottom} ${dLeft}`;
  
  const getMargin = (dTop, dRight, dBottom, dLeft, mTop, mRight, mBottom, mLeft) => 
    responsive ? `${mTop} ${mRight} ${mBottom} ${mLeft}` : `${dTop} ${dRight} ${dBottom} ${dLeft}`;


  return (
    <main style={{ maxWidth: "100%", backgroundColor: "#f5f5f5", overflow: 'hidden' }}>
      <Meta
        title="Company Registration in Bangladesh | JK Associates"
        description="Expert company registration and formation services in Bangladesh. Private limited companies, partnerships, NGO registration. 15+ years experience."
        keywords="Company Registration Bangladesh, Company Formation, Business Setup, JK Associates"
      />

      {/* Hero Section */}
      <section style={{
        background: `linear-gradient(135deg, rgba(213, 38, 38, 0.43) 0%, rgba(196, 30, 58, 0.36) 50%, rgba(220, 20, 60, 0.75) 100%), url(${require('../../assets/images/airport_bd.jpg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: isMobile ? 'scroll' : 'fixed',
        color: 'white',
        padding: isMobile ? '30px 12px 40px 12px' : responsive ? '40px 16px 50px 16px' : '80px 80px 60px 80px',
        position: 'relative',
        overflow: 'hidden',
        minHeight: responsive ? '600px' : '700px'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : '1fr 1fr',
            gap: responsive ? '30px' : '50px',
            alignItems: 'center'
          }}>
            {/* Left Content */}
            <div style={{ zIndex: 2 }}>
              <h1 style={{
                fontSize: isMobile ? '18px' : responsive ? '24px' : '48px',
                fontWeight: 'bold',
                marginBottom: isMobile ? '10px' : responsive ? '12px' : '20px',
                lineHeight: isMobile ? 1.2 : 1.3,
                letterSpacing: '-0.5px'
              }}>
                Complete <br/>
                <span style={{ fontStyle: 'italic' }}>Company Registration</span><br/>
                Partner in Bangladesh
              </h1>
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '30px',
                fontSize: responsive ? '16px' : '18px'
              }}>
                <div style={{
                  background: '#C41E3A',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <span style={{ fontSize: '24px', fontWeight: 'bold' }}>G</span>
                </div>
                <div>
                  <div style={{ fontWeight: 'bold' }}>5/5</div>
                  <div style={{ fontSize: '14px', opacity: 0.9 }}>Google Reviews</div>
                </div>
              </div>

              <p style={{
                fontSize: responsive ? '14px' : '16px',
                lineHeight: 1.6,
                marginBottom: '30px',
                opacity: 0.95
              }}>
                Expert company formation and registration services to launch your business in Bangladesh. With 15+ years of experience, we provide end-to-end solutions including private limited companies, partnerships, and NGO registration.
              </p>

              <button style={{
                backgroundColor: '#C41E3A',
                color: 'white',
                border: 'none',
                padding: responsive ? '12px 30px' : '16px 40px',
                fontSize: responsive ? '14px' : '16px',
                borderRadius: '8px',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#A01A2E';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#C41E3A';
                e.currentTarget.style.transform = 'scale(1)';
              }}>
                Get Started
              </button>
            </div>

            {/* Right Form */}
            <div style={{
              backgroundColor: 'rgba(255,255,255,0.95)',
              borderRadius: isMobile ? '8px' : '12px',
              padding: isMobile ? '14px' : responsive ? '16px' : '30px',
              boxShadow: isMobile ? '0 4px 12px rgba(0,0,0,0.15)' : '0 10px 40px rgba(0,0,0,0.2)'
            }}>
              <h3 style={{
                color: '#8B0000',
                marginBottom: '20px',
                fontSize: responsive ? '18px' : '20px',
                fontWeight: 'bold'
              }}>
                Start Your Company <br/>
                <span style={{ fontSize: responsive ? '14px' : '16px', fontWeight: 'normal', opacity: 0.7 }}>
                  Free Consultation
                </span>
              </h3>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: responsive ? '14px' : '18px',
                marginTop: responsive ? '16px' : '20px'
              }}>
                {/* Entity Type */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: responsive ? '10px' : '20px'
                }}>
                  <label style={{
                    fontSize: fontSize('16px', '12px'),
                    fontWeight: 600,
                    color: '#333',
                    whiteSpace: 'nowrap',
                    flexShrink: 0
                  }}>
                    Entity
                  </label>
                  <select
                    value={entity}
                    onChange={handleEntityChange}
                    style={{
                      flex: 1,
                      padding: responsive ? '10px 12px' : '12px 14px',
                      fontSize: fontSize('15px', '13px'),
                      border: '2px solid #e0e0e0',
                      borderRadius: '8px',
                      fontFamily: 'inherit',
                      transition: 'all 0.3s ease',
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      appearance: 'none',
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 12px center',
                      paddingRight: responsive ? '30px' : '36px'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#C41E3A';
                      e.target.style.boxShadow = '0 0 0 3px rgba(196,30,58,0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e0e0e0';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <option value="">Select Entity</option>
                    <option value="Limited / Ltd.">Limited / Ltd.</option>
                    <option value="One Person Company (OPC)">One Person Company (OPC)</option>
                    <option value="Society Registration">Society Registration</option>
                    <option value="Partnership Firm Registration">Partnership Firm Registration</option>
                  </select>
                </div>

                {/* Division */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: responsive ? '10px' : '20px'
                }}>
                  <label style={{
                    fontSize: fontSize('16px', '12px'),
                    fontWeight: 600,
                    color: '#333',
                    whiteSpace: 'nowrap',
                    flexShrink: 0
                  }}>
                    Division
                  </label>
                  <select
                    value={state}
                    onChange={handleStateChange}
                    style={{
                      flex: 1,
                      padding: responsive ? '10px 12px' : '12px 14px',
                      fontSize: fontSize('15px', '13px'),
                      border: '2px solid #e0e0e0',
                      borderRadius: '8px',
                      fontFamily: 'inherit',
                      transition: 'all 0.3s ease',
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      appearance: 'none',
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 12px center',
                      paddingRight: responsive ? '30px' : '36px'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#C41E3A';
                      e.target.style.boxShadow = '0 0 0 3px rgba(196,30,58,0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e0e0e0';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <option value="">Select Division</option>
                    <option value="Dhaka">Dhaka</option>
                    <option value="Chittagong">Chittagong</option>
                    <option value="Khulna">Khulna</option>
                    <option value="Rajshahi">Rajshahi</option>
                  </select>
                </div>
              </div>

              {/* CTA Button */}
              {(entity && state) && (
                <button
                  style={{
                    marginTop: responsive ? '18px' : '24px',
                    width: '100%',
                    padding: responsive ? '12px 20px' : '14px 32px',
                    fontSize: fontSize('16px', '13px'),
                    fontWeight: 700,
                    backgroundColor: '#C41E3A',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 8px 20px rgba(196,30,58,0.25)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                  onClick={() => {
                    window.open("https://api.whatsapp.com/send/?phone=+8801511404971&text=I%20would%20like%20to%20register%20a%20company%3A%20" + encodeURIComponent(entity + " - " + state), "_blank");
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#A01A2E';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 28px rgba(196,30,58,0.35)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#C41E3A';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(196,30,58,0.25)';
                  }}
                >
                  <span>Get Free Consultation</span>
                  <span style={{ fontSize: '14px' }}>→</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* Services Section */}
      <section style={{
        backgroundColor: '#f5f5f5',
        padding: isMobile ? '35px 12px' : responsive ? '50px 16px' : '80px 40px'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: responsive ? '40px' : '60px' }}>
            <h2 style={{
              fontSize: isMobile ? '20px' : responsive ? '24px' : '40px',
              fontWeight: 'bold',
              marginBottom: isMobile ? '6px' : responsive ? '10px' : '15px',
              color: '#000'
            }}>
              Our Services
            </h2>
            <p style={{
              fontSize: isMobile ? '11px' : responsive ? '12px' : '16px',
              color: '#666',
              margin: 0
            }}>
              Complete company formation with expert guidance!
            </p>
          </div>

          {/* Stats Row with Icons */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : responsive ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
            gap: isMobile ? '8px' : responsive ? '12px' : '25px',
            marginBottom: isMobile ? '35px' : responsive ? '50px' : '80px',
            alignItems: 'flex-start'
          }}>
            {[
              { number: '500+', label: 'Companies Registered', icon: '🏢', color: '#7ec850' },
              { number: '15,000+', label: 'Happy Clients', icon: '😊', color: '#4db8a8' },
              { number: '10,000+', label: 'Documents Processed', icon: '📄', color: '#2fa3d5' },
              { number: '15+', label: 'Years of Experience', icon: null, color: null, isText: true }
            ].map((stat, i) => (
              <div key={i} style={{
                backgroundColor: stat.color ? stat.color : 'transparent',
                color: stat.color ? 'white' : '#000',
                padding: isMobile ? '12px 10px' : responsive ? '16px 12px' : '35px 25px',
                borderRadius: isMobile ? '8px' : '16px',
                textAlign: 'center',
                boxShadow: stat.color ? '0 8px 20px rgba(0,0,0,0.1)' : 'none'
              }}>
                {stat.icon && !stat.isText && (
                  <div style={{ fontSize: '28px', marginBottom: '12px' }}>
                    {stat.icon}
                  </div>
                )}
                <div style={{
                  fontSize: responsive ? '20px' : '32px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                  lineHeight: 1.2
                }}>
                  {stat.number}
                  {stat.isText && <span style={{ fontSize: responsive ? '16px' : '20px', fontStyle: 'italic', marginLeft: '8px' }}>Years</span>}
                </div>
                <div style={{
                  fontSize: isMobile ? '10px' : responsive ? '13px' : '14px',
                  opacity: 0.9,
                  fontWeight: stat.color ? '500' : '600',
                  color: stat.color ? 'white' : '#333'
                }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          {/* Service Cards Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : responsive ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
            gap: isMobile ? '12px' : responsive ? '20px' : '35px'
          }}>
            {[
              {
                title: 'Company Registration',
                icon: '🏢',
                description: 'Complete private limited company registration in Bangladesh with expert guidance through RJSC filing, documentation, and government approvals.'
              },
              {
                title: 'Partnership Registration',
                icon: '🤝',
                description: 'Establish your partnership with comprehensive registration services, partnership deed preparation, and joint liability documentation.'
              },
              {
                title: 'NGO & Charity Registration',
                icon: '❤️',
                description: 'Expert support for NGO registration with NGO Bureau, tax exemption certificates, and compliance frameworks for non-profit organizations.'
              },
              {
                title: 'Name Clearance & Approval',
                icon: '✅',
                description: 'Quick name clearance from RJSC, business name verification, and reservation to protect your company identity and brand.'
              },
              {
                title: 'Memorandum & Articles',
                icon: '📜',
                description: 'Professional drafting of memorandum and articles of association compliant with Bangladesh Companies Act and regulatory requirements.'
              },
              {
                title: 'Government Liaisons',
                icon: '🔗',
                description: 'Dedicated government liaison services with NBR, RJSC, and regulatory bodies for seamless compliance and approvals.'
              }
            ].map((service, i) => (
              <div key={i} style={{
                backgroundColor: 'white',
                padding: isMobile ? '12px 10px' : responsive ? '16px 12px' : '35px 30px',
                borderRadius: isMobile ? '8px' : '12px',
                border: '1px solid #e8e8e8',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                minHeight: isMobile ? 'auto' : responsive ? '150px' : '220px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 12px 28px rgba(0,0,0,0.12)';
                e.currentTarget.style.transform = 'translateY(-8px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: responsive ? 'flex-start' : 'center',
                  marginBottom: responsive ? '12px' : '20px',
                  gap: responsive ? '8px' : '12px'
                }}>
                  <div style={{
                    fontSize: responsive ? '24px' : '32px',
                    flexShrink: 0
                  }}>
                    {service.icon}
                  </div>
                  <h3 style={{
                    fontSize: responsive ? '13px' : '16px',
                    fontWeight: '700',
                    color: '#000',
                    margin: 0,
                    lineHeight: 1.3
                  }}>
                    {service.title}
                  </h3>
                </div>
                <p style={{
                  fontSize: responsive ? '12px' : '14px',
                  color: '#666',
                  lineHeight: 1.5,
                  margin: 0,
                  flex: 1
                }}>
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expert Consultation CTA */}
      <section style={{
        background: 'linear-gradient(135deg, #8B0000 0%, #C41E3A 100%)',
        color: 'white',
        padding: isMobile ? '30px 12px' : responsive ? '50px 16px' : '60px 80px',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: responsive ? '24px' : '36px',
            fontWeight: 'bold',
            marginBottom: '20px'
          }}>
            Start Your Company Registration Today
          </h2>
          <p style={{
            fontSize: responsive ? '14px' : '16px',
            marginBottom: '30px',
            opacity: 0.95
          }}>
            Get expert guidance for company formation in Bangladesh. Our team is ready to help you succeed!
          </p>
          <div style={{
            display: 'flex',
            gap: responsive ? '8px' : '20px',
            justifyContent: 'center',
            flexWrap: 'wrap',
            flexDirection: responsive ? 'column' : 'row'
          }}>
            <button style={{
              backgroundColor: '#C41E3A',
              color: 'white',
              border: 'none',
              padding: responsive ? '12px 20px' : '14px 32px',
              borderRadius: '6px',
              fontSize: responsive ? '13px' : '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              width: responsive ? '100%' : 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#A01A2E';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#C41E3A';
              e.currentTarget.style.transform = 'scale(1)';
            }}>
              Schedule Now
            </button>
            <button style={{
              backgroundColor: 'transparent',
              color: 'white',
              border: '2px solid white',
              padding: responsive ? '12px 20px' : '12px 30px',
              borderRadius: '6px',
              fontSize: responsive ? '13px' : '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              width: responsive ? '100%' : 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'white';
              e.currentTarget.style.color = '#8B0000';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = 'white';
            }}>
              Learn More
            </button>
          </div>
        </div>
      </section>

      {/* Industries We Cater Section */}
      <section style={{
        backgroundColor: '#f5f5f5',
        padding: isMobile ? '35px 12px' : responsive ? '50px 16px' : '60px 80px'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: responsive ? '35px' : '50px' }}>
            <h2 style={{
              fontSize: responsive ? '22px' : '36px',
              fontWeight: 'bold',
              marginBottom: responsive ? '10px' : '15px',
              color: '#001a4d'
            }}>
              Industries We Cater
            </h2>
          </div>

          {/* Industries Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : responsive ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
            gap: isMobile ? '8px' : responsive ? '12px' : '20px'
          }}>
            {[
              { title: 'Information Technology (IT) / AI & Data Services', icon: '💻' },
              { title: 'Engineering, Procurement & Construction', icon: '🏗️' },
              { title: 'Consumer Goods / Fast-Moving Consumer Goods', icon: '📦' },
              { title: 'Aerospace / Space Technology', icon: '🛰️' },
              { title: 'Business Process Outsourcing (BPO)', icon: '👥' },
              { title: 'Healthcare & Diagnostics', icon: '🏥' },
              { title: 'Logistics Management', icon: '🚚' },
              { title: 'Management Consulting', icon: '💼' },
              { title: 'Food processing', icon: '🍽️' },
              { title: 'Education', icon: '🎓' },
              { title: 'Fitness & Lifestyle', icon: '💪' },
              { title: 'Manufacturing', icon: '🏭' }
            ].map((industry, i) => (
              <div key={i} style={{
                backgroundColor: 'white',
                padding: isMobile ? '12px 8px' : responsive ? '18px 12px' : '25px 20px',
                borderRadius: isMobile ? '8px' : '12px',
                border: '1px solid #e0e0e0',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                minHeight: isMobile ? '80px' : responsive ? '100px' : '150px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.borderColor = '#C41E3A';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = '#e0e0e0';
              }}>
                <div style={{
                  fontSize: responsive ? '28px' : '32px',
                  marginBottom: '12px'
                }}>
                  {industry.icon}
                </div>
                <p style={{
                  fontSize: responsive ? '13px' : '14px',
                  fontWeight: '600',
                  color: '#333',
                  margin: 0,
                  lineHeight: 1.4
                }}>
                  {industry.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      
      <section style={{
        backgroundColor: 'white',
        padding: isMobile ? '35px 12px' : responsive ? '50px 16px' : '60px 80px'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : '1fr 1fr',
            gap: responsive ? '25px' : '60px',
            alignItems: 'center'
          }}>
            <div>
              <h2 style={{
                fontSize: responsive ? '24px' : '32px',
                fontWeight: 'bold',
                marginBottom: '10px',
                color: '#8B0000'
              }}>
                Why Choose JK Associates
              </h2>
              <h3 style={{
                fontSize: responsive ? '18px' : '24px',
                color: '#C41E3A',
                fontWeight: 'bold',
                marginBottom: '30px'
              }}>
                For Company Registration in Bangladesh?
              </h3>
              <p style={{
                fontSize: responsive ? '14px' : '16px',
                lineHeight: 1.8,
                color: '#666',
                marginBottom: '25px'
              }}>
                Outsourcing company registration to experts is a smart business decision. Our team handles all compliance and government approvals, freeing you to focus on launching your business.
              </p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {[
                  'Fast Turnaround Time',
                  'Government Relations Expertise',
                  'Complete Documentation Support',
                  'Proven Track Record'
                ].map((item, i) => (
                  <li key={i} style={{
                    fontSize: responsive ? '14px' : '16px',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    color: '#333'
                  }}>
                    <FaCheckCircle style={{ color: '#C41E3A' }} />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div style={{
              backgroundColor: '#f5f5f5',
              padding: responsive ? '30px 20px' : '40px',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <p style={{
                fontSize: responsive ? '14px' : '16px',
                color: '#666',
                lineHeight: 1.8
              }}>
                <strong>Expert Company Registration Services for Your Success in Bangladesh</strong><br/><br/>
                We provide complete company formation and registration services to help your business start strong and compliant with all government requirements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e7fa8 0%, #2fa3d5 100%)',
        color: 'white',
        padding: isMobile ? '35px 12px' : responsive ? '50px 16px' : '60px 80px'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: responsive ? '20px' : '36px',
            fontWeight: 'bold',
            marginBottom: responsive ? '30px' : '60px',
            textAlign: 'center'
          }}>
            Our Customer Reviews
          </h2>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : '1fr 3fr',
            gap: responsive ? '30px' : '40px',
            alignItems: 'flex-start'
          }}>
            {/* Left Side - Rating Card */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center'
            }}>
              <div style={{
                fontSize: responsive ? '24px' : '32px',
                fontWeight: 'bold',
                marginBottom: '15px',
                letterSpacing: '1px'
              }}>
                EXCELLENT
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '15px',
                gap: '4px'
              }}>
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} style={{ fontSize: '32px', color: '#FFD700' }} />
                ))}
              </div>
              <div style={{
                fontSize: responsive ? '13px' : '15px',
                marginBottom: '20px',
                fontWeight: '600'
              }}>
                Based on 500+ reviews
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '15px'
              }}>
                <span style={{ fontSize: '20px' }}>G</span>
                <span style={{ fontSize: '12px', opacity: 0.9 }}>GOOGLE</span>
              </div>
            </div>

            {/* Right Side - Testimonial Cards with Navigation */}
            <div style={{
              position: 'relative'
            }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: responsive ? '1fr' : 'repeat(3, 1fr)',
                gap: responsive ? '15px' : '20px'
              }}>
                {[
                  {
                    name: 'Mohammad Hasan',
                    avatar: '👨',
                    time: '2 weeks ago',
                    rating: 5,
                    text: 'Excellent service for company registration. The team handled everything professionally and got my private limited company registered in just 15 days. Highly recommended!',
                    verified: true
                  },
                  {
                    name: 'Fatima Akter',
                    avatar: '👩',
                    time: '1 month ago',
                    rating: 5,
                    text: 'Very satisfied with JK Associates for my NGO registration. They explained every step clearly and the process was smooth. Great customer support throughout!',
                    verified: true
                  },
                  {
                    name: 'Rajib Saha',
                    avatar: '👨',
                    time: '3 weeks ago',
                    rating: 5,
                    text: 'Got my partnership deed drafted and registered through them. Professional team, quick turnaround, and competitive pricing. Best service in Dhaka for business registration!',
                    verified: true
                  }
                ].map((testimonial, i) => (
                  <div key={i} style={{
                    backgroundColor: 'white',
                    padding: responsive ? '20px' : '24px',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                  }}>
                    {/* Header with name, avatar, time */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '12px'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        flex: 1
                      }}>
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#ddd',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '20px'
                        }}>
                          {testimonial.avatar}
                        </div>
                        <div>
                          <div style={{
                            fontWeight: '600',
                            color: '#333',
                            fontSize: responsive ? '13px' : '14px'
                          }}>
                            {testimonial.name}
                          </div>
                          <div style={{
                            fontSize: '12px',
                            color: '#999'
                          }}>
                            {testimonial.time}
                          </div>
                        </div>
                      </div>
                      <div style={{
                        fontSize: '16px'
                      }}>
                        G
                      </div>
                    </div>

                    {/* Rating */}
                    <div style={{
                      display: 'flex',
                      gap: '2px',
                      marginBottom: '12px'
                    }}>
                      {[...Array(testimonial.rating)].map((_, j) => (
                        <FaStar key={j} style={{ color: '#FFD700', fontSize: '14px' }} />
                      ))}
                      {[...Array(5 - testimonial.rating)].map((_, j) => (
                        <FaStar key={`empty-${j}`} style={{ color: '#ddd', fontSize: '14px' }} />
                      ))}
                      {testimonial.verified && (
                        <div style={{ marginLeft: '4px', fontSize: '10px', color: '#C41E3A' }}>✓</div>
                      )}
                    </div>

                    {/* Review Text */}
                    <p style={{
                      fontSize: responsive ? '13px' : '14px',
                      color: '#666',
                      lineHeight: 1.6,
                      marginBottom: '12px',
                      margin: 0
                    }}>
                      {testimonial.text}
                    </p>

                    {/* Read more link */}
                    <a href="#" style={{
                      fontSize: '12px',
                      color: '#999',
                      textDecoration: 'none',
                      cursor: 'pointer'
                    }}>
                      Read more
                    </a>
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              {!responsive && (
                <>
                  <button style={{
                    position: 'absolute',
                    left: '-50px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    border: '1px solid white',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)';
                  }}>
                    ‹
                  </button>
                  <button style={{
                    position: 'absolute',
                    right: '-50px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    border: '1px solid white',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)';
                  }}>
                    ›
                  </button>
                </>
              )}
            </div>
          </div>

          {/* Verified Badge */}
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: responsive ? '20px' : '30px'
          }}>
            <div style={{
              backgroundColor: '#27ae60',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '6px',
              fontSize: '12px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}>
              ✓ Verified by Trustindex
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section style={{
        backgroundColor: 'white',
        padding: isMobile ? '35px 12px' : responsive ? '50px 16px' : '60px 80px',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h3 style={{
            fontSize: responsive ? '18px' : '20px',
            color: '#666',
            marginBottom: '30px',
            fontWeight: '600'
          }}>
            Government Affiliations
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
            gap: responsive ? '20px' : '40px',
            alignItems: 'center'
          }}>
            {['RJSC', 'NBR', 'NGO Bureau', 'BIN'].map((partner, i) => (
              <div key={i} style={{
                padding: responsive ? '15px' : '20px',
                backgroundColor: '#f9f9f9',
                borderRadius: '8px',
                fontSize: responsive ? '14px' : '16px',
                fontWeight: 'bold',
                color: '#666'
              }}>
                {partner}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section style={{
        backgroundColor: '#f8f9fa',
        padding: isMobile ? '35px 12px' : responsive ? '50px 16px' : '80px 40px'
      }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: responsive ? '40px' : '60px' }}>
            <h2 style={{
              fontSize: responsive ? '22px' : '42px',
              fontWeight: 'bold',
              marginBottom: responsive ? '10px' : '15px',
              color: '#001a4d'
            }}>
              Frequently Asked Questions
            </h2>
            <p style={{
              fontSize: responsive ? '12px' : '16px',
              color: '#666',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Find answers to common questions about our company registration and business formation services.
            </p>
          </div>

          {/* FAQ Items */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: responsive ? '12px' : '16px'
          }}>
            {[
              {
                question: 'How long does company registration take?',
                answer: 'Typically, we complete private limited company registration within 15-20 business days from the date of document submission. The timeline may vary based on RJSC processing and document verification requirements.'
              },
              {
                question: 'What documents are required for company registration?',
                answer: 'Required documents include valid ID/passport of directors, proof of address, memorandum & articles of association, board resolution, and NOC from landlord (if applicable). We provide a complete checklist during consultation.'
              },
              {
                question: 'Do you provide ongoing compliance support?',
                answer: 'Yes, we offer comprehensive post-registration services including annual filing, tax compliance, financial reporting, and government liaison support to ensure your company remains fully compliant.'
              },
              {
                question: 'What is the cost of company registration in Bangladesh?',
                answer: 'Our registration packages start from competitive rates depending on company type and service complexity. We offer transparent pricing with no hidden charges. Please contact us for detailed quotation.'
              },
              {
                question: 'Can you assist with NGO and charity registration?',
                answer: 'Absolutely! We specialize in NGO registration with the NGO Bureau, including tax exemption certificates, compliance frameworks, and ongoing regulatory support for non-profit organizations.'
              },
              {
                question: 'Do you handle trademark and copyright registration?',
                answer: 'Yes, we provide intellectual property services including trademark registration, copyright filing, and brand protection services through government agencies and international bodies.'
              }
            ].map((faq, index) => {
              const [expanded, setExpanded] = useState(false);
              return (
                <div
                  key={index}
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    border: '1px solid #e5e7eb',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                  }}
                >
                  <button
                    onClick={() => setExpanded(!expanded)}
                    style={{
                      width: '100%',
                      padding: responsive ? '16px' : '20px',
                      backgroundColor: 'transparent',
                      border: 'none',
                      textAlign: 'left',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      transition: 'background-color 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f9fafb';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <h3 style={{
                      fontSize: responsive ? '14px' : '16px',
                      fontWeight: '600',
                      color: '#001a4d',
                      margin: 0,
                      flex: 1
                    }}>
                      {faq.question}
                    </h3>
                    <div style={{
                      fontSize: responsive ? '18px' : '20px',
                      color: '#C41E3A',
                      transition: 'transform 0.3s',
                      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      marginLeft: '12px',
                      flexShrink: 0
                    }}>
                      ▼
                    </div>
                  </button>

                  {expanded && (
                    <div style={{
                      padding: responsive ? '0 16px 16px 16px' : '0 20px 20px 20px',
                      borderTop: '1px solid #e5e7eb',
                      backgroundColor: '#fafbfc'
                    }}>
                      <p style={{
                        fontSize: responsive ? '13px' : '14px',
                        color: '#666',
                        lineHeight: 1.8,
                        margin: 0
                      }}>
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* CTA */}
          <div style={{
            marginTop: responsive ? '40px' : '60px',
            padding: responsive ? '25px' : '35px',
            backgroundColor: 'linear-gradient(135deg, #8B0000 0%, #C41E3A 100%)',
            backgroundImage: 'linear-gradient(135deg, #8B0000 0%, #C41E3A 100%)',
            borderRadius: '12px',
            textAlign: 'center'
          }}>
            <h3 style={{
              fontSize: responsive ? '18px' : '22px',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '10px',
              margin: 0
            }}>
              Didn't find your answer?
            </h3>
            <p style={{
              fontSize: responsive ? '13px' : '14px',
              color: 'rgba(255,255,255,0.9)',
              marginBottom: '20px',
              margin: '10px 0 20px 0'
            }}>
              Our expert team is ready to help. Contact us for personalized guidance.
            </p>
            <button style={{
              backgroundColor: '#FFD700',
              color: '#8B0000',
              border: 'none',
              padding: responsive ? '10px 24px' : '12px 32px',
              borderRadius: '6px',
              fontSize: responsive ? '13px' : '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.backgroundColor = '#FFC700';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.backgroundColor = '#FFD700';
            }}>
              Contact Our Experts
            </button>
          </div>
        </div>
      </section>

    </main>
  );
}